export enum FluxoRelacionamentoTipo {
  Agenda = 'agenda',
}
